// import React from 'react';
// import {
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Box,
//   Typography,
//   useTheme,
//   Avatar,
//   CircularProgress,
// } from '@mui/material';
// import { gql, useMutation } from '@apollo/client';

// // Use the same icon as the Add User form
// const FORM_ICON_URL = `${process.env.PUBLIC_URL}/delete-bin-icon.svg`;

// // Defines the structure of the user data to be displayed in the dialog
// export interface UserToDeleteDetails {
//   actualUserId: string;
//   name: string;
//   email: string;
//   avatarUrl?: string;
//   role: string;
// }

// // Defines the props expected by the DeleteUserDialog component
// interface DeleteUserDialogProps {
//   open: boolean;
//   onClose: () => void;
//   onUserDeleted: (userId: string) => void;
//   userToDelete: UserToDeleteDetails | null;
//   tenantId: string | null;
// }

// // GraphQL Mutation for removing a user from a tenant
// const REMOVE_USER_FROM_TENANT = gql`
//   mutation RemoveUserFromTenant($userId: ID!, $tenantId: ID!) {
//     removeUserFromTenant(userId: $userId, tenantId: $tenantId) {
//       id
//     }
//   }
// `;

// const roleDotColors: { [key:string]: string } = {
//     Admin: '#FF9900',
//     Editor: '#0064FF',
//     Viewer: '#6C737F',
// };


// const DeleteUserDialog: React.FC<DeleteUserDialogProps> = ({
//   open,
//   onClose,
//   onUserDeleted,
//   userToDelete,
//   tenantId,
// }) => {
//   const theme = useTheme();
//   const [error, setError] = React.useState<string | null>(null);

//   const [removeUserMutation, { loading: isDeleting }] = useMutation(
//     REMOVE_USER_FROM_TENANT,
//     {
//       onCompleted: (data) => {
//         if (userToDelete) {
//           onUserDeleted(userToDelete.actualUserId);
//         }
//         onClose();
//       },
//       onError: (err) => {
//         setError(err.graphQLErrors?.[0]?.message || err.message || 'Failed to delete user. Please try again.');
//       },
//     }
//   );

//   const handleConfirmDelete = async () => {
//     setError(null);
//     if (!userToDelete || !tenantId) {
//       setError('User data or Tenant ID is missing. Cannot delete.');
//       return;
//     }

//     try {
//       await removeUserMutation({
//         variables: {
//           userId: userToDelete.actualUserId,
//           tenantId: tenantId,
//         },
//       });
//     } catch (err) {
//       // Error is handled by the useMutation onError callback
//     }
//   };

//   if (!userToDelete) {
//     return null;
//   }

//   const getInitials = (name: string) => {
//     if (!name) return '';
//     const parts = name.split(' ');
//     if (parts.length > 1) {
//       return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
//     }
//     return name.substring(0, 2).toUpperCase();
//   };


//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       PaperProps={{
//         sx: {
//           borderRadius: '16px',
//           maxWidth: '600px', // Matched from adduser
//           // REMOVED backgroundImage, backgroundRepeat, backgroundSize from here
//         }
//       }}
//       BackdropProps={{ sx: { backdropFilter: 'blur(5px)' } }}
//       fullWidth
//       sx={{ zIndex: 1302 }} // Kept zIndex high for stacking
//     >
//       {/* --- DIALOG TITLE STYLED EXACTLY AS ADDUSER --- */}
//       {/* --- DIALOG TITLE WITH UPDATED STYLING --- */}
//       <DialogTitle sx={{
//         p: theme.spacing(2, 3),
//         backgroundImage: `
//           linear-gradient(to bottom, transparent 80%, white 100%),
//           url('/red-bg-form.svg')
//         `,
//         backgroundRepeat: 'no-repeat',
//         backgroundPosition: 'center',
//         backgroundSize: 'cover',
//         borderTopRightRadius: '16px',
//         borderTopLeftRadius: '16px',
//       }}>
//         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//             <Box component="span" sx={{ mt: 3, width: 48, height: 48, borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1.5, backgroundColor:'#F9E9E8', boxShadow: '0px 1px 2px 0px rgba(10, 13, 18, 0.05)' }}>
//               <img src={FORM_ICON_URL} alt="Form Icon" style={{ width: '20px'}} />
//             </Box>
//             <Box>
//               <Typography
//                 variant="h6"
//                 component="div"
//                 sx={{
//                   fontFamily:'Inter',
//                   fontWeight: 600,
//                   fontSize: '16px',
//                   mb:0.3,
//                   mt: 3,
//                   color: 'rgba(3, 23, 52, 1)' // Dark color for contrast
//                 }}
//               >
//                 Delete User
//               </Typography>
//               <Typography
//                 variant="body2"
//                 color="text.secondary"
//                 sx={{
//                   fontFamily:'Inter',
//                   fontSize: '14px',
//                   fontWeight: 400,
//                   color: 'rgba(71, 84, 103, 1)' // Dark grey for contrast
//                 }}
//               >
//                 This action will permanently remove the user.
//               </Typography>
//             </Box>
//           </Box>
//         </Box>
//       </DialogTitle>

//       {/* --- DIALOG CONTENT STYLED EXACTLY AS ADDUSER --- */}
//       <DialogContent sx={{ p: 3 }}>
//         {error && (
//             <Typography color="error" sx={{ mb: 2, textAlign: 'center', fontSize: '14px' }}>
//                 {error}
//             </Typography>
//         )}
//         <Box sx={{ mt: 5 }}> {/* Added Box with margin-top to match adduser spacing */}
//             <Typography variant="body2" color="text.secondary" sx={{ fontFamily:'Inter', mb: 2.5, fontSize: '14px', textAlign: 'center' }}>
//               You are about to remove the following user from the system. Please confirm.
//             </Typography>

//             <Box sx={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 p: 1.5,
//                 border: `1px solid ${theme.palette.divider}`,
//                 borderRadius: '8px',
//                 backgroundColor: theme.palette.background.default,
//                 mb: 2,
//             }}>
//                 <Avatar
//                     src={userToDelete.avatarUrl}
//                     sx={{ width: 40, height: 40, mr: 1.5, fontFamily: 'Inter', fontSize: '14px' }}
//                 >
//                     {getInitials(userToDelete.name)}
//                 </Avatar>
//                 <Box sx={{ flexGrow: 1 }}>
//                     <Typography variant="subtitle2" sx={{ fontFamily: 'Inter', fontWeight: 500, color: theme.palette.text.primary }}>
//                         {userToDelete.name}
//                     </Typography>
//                     <Typography variant="body2" sx={{ fontFamily: 'Inter', color: theme.palette.text.secondary, fontSize: '12px' }}>
//                         {userToDelete.email}
//                     </Typography>
//                 </Box>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, ml: 1 }}>
//                     <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: roleDotColors[userToDelete.role] || theme.palette.grey[400], flexShrink: 0 }} />
//                     <Typography variant="body2" sx={{ fontFamily: 'Inter', color: theme.palette.text.secondary, fontSize: '12px' }}>
//                         {userToDelete.role}
//                     </Typography>
//                 </Box>
//             </Box>
//         </Box>
//       </DialogContent>

//       {/* --- DIALOG ACTIONS STYLED EXACTLY AS ADDUSER --- */}
//       <DialogActions sx={{ p: theme.spacing(2, 3) }}>
//         <Button
//           onClick={onClose}
//           variant="outlined"
//           disabled={isDeleting}
//           sx={{
//             width: '120px',
//             borderRadius: '8px', color: 'rgba(52, 64, 84, 1)', borderColor: 'rgba(208, 213, 221, 1)',
//             '&:hover': { borderColor: theme.palette.grey[700], backgroundColor: 'action.hover' },
//             py: '8px', textTransform: 'none', fontWeight: 500, fontSize: '14px', fontFamily:'Inter',
//           }}
//         >
//           Cancel
//         </Button>
//         <Button
//           onClick={handleConfirmDelete}
//           variant="contained"
//           color="primary" // Style as primary button like adduser
//           disabled={isDeleting}
//           sx={{
//             width: '120px',
//             py: '8px', borderRadius:'8px', textTransform: 'none',
//             fontWeight: 500, fontSize: '14px', fontFamily:'Inter',
//             backgroundColor: theme.palette.error.main,
//             '&:hover': { backgroundColor: theme.palette.error.dark },
//             '&.Mui-disabled': {
//                 backgroundColor: 'rgba(224, 224, 224, 1)',
//                 color: 'rgba(173, 173, 173, 1)'
//             }
//           }}
//           startIcon={isDeleting ? <CircularProgress size={16} color="inherit" /> : null}
//         >
//           {isDeleting ? 'Deleting...' : 'Delete'}
//         </Button>
//       </DialogActions>
//     </Dialog>
    
//   );
// };

// export default DeleteUserDialog;

import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Typography,
  useTheme,
  Avatar,
  CircularProgress,
  Snackbar,
  Alert,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { gql, useMutation } from '@apollo/client';

// Use the same icon as the Add User form
const FORM_ICON_URL = `${process.env.PUBLIC_URL}/delete-bin-icon.svg`;

// Defines the structure of the user data to be displayed in the dialog
export interface UserToDeleteDetails {
  actualUserId: string;
  name: string;
  email: string;
  avatarUrl?: string;
  role: string;
}

// Defines the props expected by the DeleteUserDialog component
interface DeleteUserDialogProps {
  open: boolean;
  onClose: () => void;
  onUserDeleted: (userId: string) => void;
  userToDelete: UserToDeleteDetails | null;
  tenantId: string | null;
}

// GraphQL Mutation for removing a user from a tenant
const REMOVE_USER_FROM_TENANT = gql`
  mutation RemoveUserFromTenant($userId: ID!, $tenantId: ID!) {
    removeUserFromTenant(userId: $userId, tenantId: $tenantId) {
      id
    }
  }
`;

const roleDotColors: { [key:string]: string } = {
    Admin: '#FF9900',
    Editor: '#0064FF',
    Viewer: '#6C737F',
};

// Custom icon for the error toast
const CustomErrorIcon = () => (
    <Box
      component="span"
      sx={{
        width: 24,
        height: 24,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#D92D20',
      }}
    >
      <CloseIcon sx={{ color: 'white', fontSize: '16px' }} />
    </Box>
);


const DeleteUserDialog: React.FC<DeleteUserDialogProps> = ({
  open,
  onClose,
  onUserDeleted,
  userToDelete,
  tenantId,
}) => {
  const theme = useTheme();
  const [isToastOpen, setIsToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState<string | null>(null);


  const [removeUserMutation, { loading: isDeleting }] = useMutation(
    REMOVE_USER_FROM_TENANT,
    {
      onCompleted: (data) => {
        if (userToDelete) {
          onUserDeleted(userToDelete.actualUserId);
        }
        onClose();
      },
      onError: (err) => {
        // Set the custom toast message on error
        setToastMessage('We are unable to delete user at this moment please try again after some time');
        setIsToastOpen(true);
      },
    }
  );

  const handleToastClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setIsToastOpen(false);
  };

  const handleConfirmDelete = async () => {
    if (!userToDelete || !tenantId) {
      setToastMessage('User data or Tenant ID is missing. Cannot delete.');
      setIsToastOpen(true);
      return;
    }

    try {
      await removeUserMutation({
        variables: {
          userId: userToDelete.actualUserId,
          tenantId: tenantId,
        },
      });
    } catch (err) {
      // Error is handled by the useMutation onError callback
    }
  };

  if (!userToDelete) {
    return null;
  }

  const getInitials = (name: string) => {
    if (!name) return '';
    const parts = name.split(' ');
    if (parts.length > 1) {
      return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };


  return (
    // FIX: Added React Fragment to wrap Dialog and Snackbar
    <>
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            borderRadius: '16px',
            maxWidth: '600px',
          }
        }}
        BackdropProps={{ sx: { backdropFilter: 'blur(5px)' } }}
        fullWidth
        sx={{ zIndex: 1302 }}
      >
        <DialogTitle sx={{
          p: theme.spacing(2, 3),
          backgroundImage: `
            linear-gradient(to bottom, transparent 80%, white 100%),
            url('/red-bg-form.svg')
          `,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          borderTopRightRadius: '16px',
          borderTopLeftRadius: '16px',
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box component="span" sx={{ mt: 3, width: 48, height: 48, borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1.5, backgroundColor:'#F9E9E8', boxShadow: '0px 1px 2px 0px rgba(10, 13, 18, 0.05)' }}>
                <img src={FORM_ICON_URL} alt="Form Icon" style={{ width: '20px'}} />
              </Box>
              <Box>
                <Typography
                  variant="h6"
                  component="div"
                  sx={{
                    fontFamily:'Inter',
                    fontWeight: 600,
                    fontSize: '16px',
                    mb:0.3,
                    mt: 3,
                    color: 'rgba(3, 23, 52, 1)'
                  }}
                >
                  Delete User
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    fontFamily:'Inter',
                    fontSize: '14px',
                    fontWeight: 400,
                    color: 'rgba(71, 84, 103, 1)'
                  }}
                >
                  This action will permanently remove the user.
                </Typography>
              </Box>
            </Box>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ p: 3 }}>
          {/* FIX: Removed the old inline error message */}
          <Box sx={{ mt: 5 }}>
              <Typography variant="body2" color="text.secondary" sx={{ fontFamily:'Inter', mb: 2.5, fontSize: '14px', textAlign: 'center' }}>
                You are about to remove the following user from the system. Please confirm.
              </Typography>

              <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  p: 1.5,
                  border: `1px solid ${theme.palette.divider}`,
                  borderRadius: '8px',
                  backgroundColor: theme.palette.background.default,
                  mb: 2,
              }}>
                  <Avatar
                      src={userToDelete.avatarUrl}
                      sx={{ width: 40, height: 40, mr: 1.5, fontFamily: 'Inter', fontSize: '14px' }}
                  >
                      {getInitials(userToDelete.name)}
                  </Avatar>
                  <Box sx={{ flexGrow: 1 }}>
                      <Typography variant="subtitle2" sx={{ fontFamily: 'Inter', fontWeight: 500, color: theme.palette.text.primary }}>
                          {userToDelete.name}
                      </Typography>
                      <Typography variant="body2" sx={{ fontFamily: 'Inter', color: theme.palette.text.secondary, fontSize: '12px' }}>
                          {userToDelete.email}
                      </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, ml: 1 }}>
                      <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: roleDotColors[userToDelete.role] || theme.palette.grey[400], flexShrink: 0 }} />
                      <Typography variant="body2" sx={{ fontFamily: 'Inter', color: theme.palette.text.secondary, fontSize: '12px' }}>
                          {userToDelete.role}
                      </Typography>
                  </Box>
              </Box>
          </Box>
        </DialogContent>

        <DialogActions sx={{ p: theme.spacing(2, 3) }}>
          <Button
            onClick={onClose}
            variant="outlined"
            disabled={isDeleting}
            sx={{
              width: '120px',
              borderRadius: '8px', color: 'rgba(52, 64, 84, 1)', borderColor: 'rgba(208, 213, 221, 1)',
              '&:hover': { borderColor: theme.palette.grey[700], backgroundColor: 'action.hover' },
              py: '8px', textTransform: 'none', fontWeight: 500, fontSize: '14px', fontFamily:'Inter',
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            variant="contained"
            disabled={isDeleting}
            sx={{
              width: '120px',
              py: '8px', borderRadius:'8px', textTransform: 'none',
              fontWeight: 500, fontSize: '14px', fontFamily:'Inter',
              backgroundColor: theme.palette.error.main,
              '&:hover': { backgroundColor: theme.palette.error.dark },
              '&.Mui-disabled': {
                  backgroundColor: 'rgba(224, 224, 224, 1)',
                  color: 'rgba(173, 173, 173, 1)'
              }
            }}
            startIcon={isDeleting ? <CircularProgress size={16} color="inherit" /> : null}
          >
            {isDeleting ? 'Deleting...' : 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* FIX: Integrated Snackbar with correct state and handlers */}
      <Snackbar
        open={isToastOpen}
        autoHideDuration={6000}
        onClose={handleToastClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          icon={<CustomErrorIcon />} 
          onClose={handleToastClose}
          sx={{
            width: '100%',
            borderRadius: '50px',
            backgroundColor: 'white',
            boxShadow: theme.shadows[3],
            color: 'text.secondary',
            alignItems: 'center',
            p: theme.spacing(0.5, 2),
            '& .MuiAlert-message': {
              flex: 1,
              py: '12px'
            },
          }}
        >
          {toastMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default DeleteUserDialog;